import { CallApi } from "app/_helpers/CallApi/CallApi";
import { DDMMYYYYFormat, YYYYMMDDHHMMAFormat } from "app/_helpers/dateHelper";
import {
  MEDICAL_STATUS,
  MEDICAL_STATUS_VIEW,
  MEDICAL_TYPE_VIEW,
} from "app/_pages/_healthSafetyEnvironment/Medical/Constant";
import { TRAINEE_TYPE } from "app/_pages/_healthSafetyEnvironment/TrainingManagement/CONSTANTS";
import { EMPLOYEE_MEDICAL_CATEGORY } from "app/_pages/UserManagement/Employee/Constant.js";
import {
  getAllOldEmployee,
  getEmployee,
  getEmployeeForOtherModuel,
} from "../UserManagement/EmployeeService";
import {
  getAllContractorPerson,
  getAllOldContPerson,
  getContPersonForOtherModuel,
} from "../UserManagement/ContractorPersonService";
import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
import { GetPMEDueDate, calaculateDatesDifference } from "app/_helpers/helper";
let { Store } = configureStore();

const formattedMedicalData = (data, employeeList, contractorStaffList) => {
  const formattedData = data?.map((d, index) => {
    let objData = {};
    if (d?.medicalAssigneeType === "employee") {
      objData = (employeeList?.data || [])?.find(
        (obj) => obj?.id === d?.medicalAssigneeId
      );
    } else if (d?.medicalAssigneeType === "contractorPerson") {
      objData = (contractorStaffList?.data || [])?.find(
        (obj) => obj?.id === d?.medicalAssigneeId
      );
    }
    let age = calaculateDatesDifference(objData?.dob, objData?.startDateAtMines);

    let nextPMEDueDate = "";
    if (objData?.lastPMEDate || objData?.lastIMEDate) {
      nextPMEDueDate = GetPMEDueDate({
        pmeDate: objData?.lastPMEDate || objData?.lastIMEDate,
        startDateAtMine: objData?.startDateAtMines,
        age: age,
      });
    }
    return {
      ...d,
      sid: index + 1,
      medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
      medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
      medicalAssigneeNameId: d?.medicalAssigneeId,
      categoryName: d?.categoryData?.name,

      mineName: d?.siteData?.name,

      medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
      assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
      medicalCategoryName: d?.medicalCategoryData?.name,
      medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
        (sub) => sub.id === d?.medicalSubCategory
      )?.name,

      assigneeID: objData ? objData?.srNo || objData?.employeeId : "",
      assigneeName: objData ? `${objData?.firstName} ${objData?.lastName}` : "",
      assigneeDesignation: objData ? objData?.srNo || objData?.employeeId : "",
      formA: objData
        ? // ? objData?.contractorFormA?.serialNumberOmc ||
          objData?.srNo || objData?.employeeFormA?.serialNumberOmc
        : "",

      dueDateView: d?.dueDate,
      medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
      medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
      smeCategoryView: EMPLOYEE_MEDICAL_CATEGORY[d?.smeCategory],
      lastPMEDate: objData?.lastPMEDate,
      lastIMEDate: objData?.lastIMEDate,
      nextPMEDate: nextPMEDueDate,
      currentLocation: objData?.ehsSite?.name || "",
    };
  });
  return formattedData;
};

export async function getMedicalList(filter) {
  const medicalData = Store.getState()?.userManagement?.medicalAll;
  if (
    Array.isArray(medicalData?.data) &&
    medicalData?.data?.length &&
    filter === "activeAssigneeMedical"
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: medicalData.data,
        });
      }, 0);
    });
  }
  let url =
    "/global-configuration/ehs-module/all-medical-assigners" +
    (filter ? `/${filter}` : "");
  const result = await CallApi(url, "GET");
  // const employeeList = await getEmployee();
  // const contractorStaffList = await getAllContractorPerson();
  const employeeList = await getEmployeeForOtherModuel();
  const contractorStaffList = await getContPersonForOtherModuel();
  const oldEmployeeList = await getAllOldEmployee();
  const oldContractorStaffList = await getAllOldContPerson();

  const { status, message, data = [] } = result;
  const filteredData = data?.map((d, index) => {
    let objData = {};
    if (d?.medicalAssigneeType === "employee") {
      objData =
        (employeeList?.data || [])?.find((obj) => obj?.id === d?.medicalAssigneeId) ||
        (oldEmployeeList?.data || [])?.find((obj) => obj?.id === d?.medicalAssigneeId);
    } else if (d?.medicalAssigneeType === "contractorPerson") {
      objData =
        (contractorStaffList?.data || [])?.find(
          (obj) => obj?.id === d?.medicalAssigneeId
        ) ||
        (oldContractorStaffList?.data || [])?.find(
          (obj) => obj?.id === d?.medicalAssigneeId
        );
    }
    let age = calaculateDatesDifference(objData?.dob, objData?.startDateAtMines);

    let nextPMEDueDate = "";
    if (objData?.lastPMEDate || objData?.lastIMEDate) {
      nextPMEDueDate = GetPMEDueDate({
        pmeDate: objData?.lastPMEDate || objData?.lastIMEDate,
        startDateAtMine: objData?.startDateAtMines,
        age: age,
      });
    }
    return {
      ...d,
      sid: index + 1,
      medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
      medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
      medicalAssigneeNameId: d?.medicalAssigneeId,
      categoryName: d?.categoryData?.name,

      mineName: d?.siteData?.name,

      medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
      assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
      medicalCategoryName: d?.medicalCategoryData?.name,
      medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
        (sub) => sub.id === d?.medicalSubCategory
      )?.name,

      assigneeID: objData ? objData?.srNo || objData?.employeeId : "",
      assigneeName: objData ? `${objData?.firstName} ${objData?.lastName}` : "",
      assigneeDesignation: objData ? objData?.srNo || objData?.employeeId : "",
      formA: objData
        ? // ? objData?.contractorFormA?.serialNumberOmc ||
          objData?.srNo || objData?.employeeFormA?.serialNumberOmc
        : "",

      dueDateView: d?.dueDate,
      medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
      medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
      smeCategoryView: EMPLOYEE_MEDICAL_CATEGORY[d?.smeCategory],
      lastPMEDate: objData?.lastPMEDate,
      lastIMEDate: objData?.lastIMEDate,
      nextPMEDate: nextPMEDueDate,
    };
  });
  if (result.status && filter === "activeAssigneeMedical")
    Store.dispatch({
      type: USER_DATA_CONSTANT.MEDICAL_ALL,
      data: filteredData,
    });
  return {
    status,
    message,
    data: filteredData,
  };
}

export async function getInActiveStaffMedicalList(tabType) {
  let storeKey =
    tabType === "unAssigned" ? "medicalInActiveUnassigned" : "medicalInActiveAssigned";
  const medicalData = Store.getState()?.userManagement?.[storeKey];
  if (Array.isArray(medicalData?.data) && medicalData?.data?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: medicalData.data,
        });
      }, 0);
    });
  }
  let url =
    "/global-configuration/ehs-module/all-medical-inActive-staff" +
    (tabType ? `/${tabType}` : "");
  const result = await CallApi(url, "GET");
  const employeeList = await getAllOldEmployee();
  const contractorStaffList = await getAllOldContPerson();
  const { status, message, data = [] } = result;
  const filteredData = formattedMedicalData(data, employeeList, contractorStaffList);
  if (result.status && tabType === "unAssigned")
    Store.dispatch({
      type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_UNASSIGNED,
      data: filteredData,
    });
  if (result.status && tabType === "assigned")
    Store.dispatch({
      type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_ASSIGNED,
      data: filteredData,
    });
  return {
    status,
    message,
    data: filteredData,
  };
}

export async function getAllMedical(filter) {
  const medicalData = Store.getState()?.userManagement?.medicalAllData;
  if (Array.isArray(medicalData?.data) && medicalData?.data?.length && !filter) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: medicalData.data,
        });
      }, 0);
    });
  }
  let url =
    "/global-configuration/ehs-module/all-done-medical-assigners" +
    (filter ? `/${filter}` : "");
  const result = await CallApi(url, "GET");
  const { status, message, data = [] } = result;
  if (result.status && !filter)
    Store.dispatch({
      type: USER_DATA_CONSTANT.MEDICAL_ALL_DONE,
      data: data?.map((d, index) => {
        return {
          ...d,
          id: `${d?.id}_${d?.medicalTestType}`,
          sid: index + 1,
          medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
          medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
          medicalAssigneeNameId: d?.medicalAssigneeId,
          categoryName: d?.categoryData?.name,
          mineName: d?.siteData?.name,
          medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
          assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
          medicalCategoryName: d?.medicalCategoryData?.name,
          medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
            (sub) => sub.id === d?.medicalSubCategory
          )?.name,
          assigneeID: d?.employeeType === "contractorPerson" ? d?.srNo : d?.employeeId,
          assigneeName: `${d?.firstName} ${d?.lastName}`,
          formA: d?.srNo || d?.employeeFormA?.serialNumberOmc || "",
          dueDateView: d?.dueDate,
          siteId: d?.currentWorkLocation,
          medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
          medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
          smeCategoryView: EMPLOYEE_MEDICAL_CATEGORY[d?.smeCategory],
          lastPMEDate: d?.lastPMEDate,
          lastIMEDate: d?.lastIMEDate,
          nextPMEDate: d?.nextPMEDate,
        };
      }),
    });
  return {
    status,
    message,
    data: data?.map((d, index) => {
      return {
        ...d,
        id: `${d?.id}_${d?.medicalTestType}`,
        sid: index + 1,
        medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
        medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
        medicalAssigneeNameId: d?.medicalAssigneeId,
        categoryName: d?.categoryData?.name,
        mineName: d?.siteData?.name,
        medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
        assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
        medicalCategoryName: d?.medicalCategoryData?.name,
        medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
          (sub) => sub.id === d?.medicalSubCategory
        )?.name,
        assigneeID: d?.employeeType === "contractorPerson" ? d?.srNo : d?.employeeId,
        assigneeName: `${d?.firstName} ${d?.lastName}`,
        formA: d?.srNo || d?.employeeFormA?.serialNumberOmc || "",
        dueDateView: d?.dueDate,
        siteId: d?.currentWorkLocation,
        medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
        medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
        smeCategoryView: EMPLOYEE_MEDICAL_CATEGORY[d?.smeCategory],
        lastPMEDate: d?.lastPMEDate,
        lastIMEDate: d?.lastIMEDate,
        nextPMEDate: d?.nextPMEDate,
      };
    }),
  };
}

export const getAllMedicalHistory = async () => {
  let url = "/global-configuration/ehs-module/login-user-medical-approval-history";
  const result = await CallApi(url, "GET");

  const { status, message, data = [] } = result;

  return {
    status,
    message,
    data: {
      medicalOfficer: data?.medicalOfficer?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
          medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
          medicalAssigneeNameId: d?.medicalAssigneeId,

          mineName: d?.siteData?.name,

          medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
          assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
          medicalCategoryName: d?.medicalCategoryData?.name,
          medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
            (sub) => sub.id === d?.medicalSubCategory
          )?.name,

          assigneeID: d?.medicalAssigneeData?.srNo || d?.medicalAssigneeData?.employeeId,
          assigneeName: `${d?.medicalAssigneeData?.firstName} ${d?.medicalAssigneeData?.lastName}`,
          assigneeDesignation:
            d?.medicalAssigneeData?.srNo || d?.medicalAssigneeData?.employeeId,
          formA:
            d?.medicalAssigneeData?.srNo ||
            d?.medicalAssigneeData?.employeeFormA?.serialNumberOmc,

          dueDateView: DDMMYYYYFormat(d?.dueDate),
          medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
          medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
        };
      }),
      minesManager: data?.minesManager?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
          medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
          medicalAssigneeNameId: d?.medicalAssigneeId,

          mineName: d?.siteData?.name,

          medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
          assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
          medicalCategoryName: d?.medicalCategoryData?.name,
          medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
            (sub) => sub.id === d?.medicalSubCategory
          )?.name,

          assigneeID: d?.medicalAssigneeData?.srNo || d?.medicalAssigneeData?.employeeId,
          assigneeName: `${d?.medicalAssigneeData?.firstName} ${d?.medicalAssigneeData?.lastName}`,
          assigneeDesignation:
            d?.medicalAssigneeData?.srNo || d?.medicalAssigneeData?.employeeId,
          formA:
            d?.medicalAssigneeData?.srNo ||
            d?.medicalAssigneeData?.employeeFormA?.serialNumberOmc,

          dueDateView: DDMMYYYYFormat(d?.dueDate),
          medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
          medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
        };
      }),
      safetyOfficer: data?.safetyOfficer?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
          medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalStatus],
          medicalAssigneeNameId: d?.medicalAssigneeId,

          mineName: d?.siteData?.name,

          medicalTypeView: MEDICAL_TYPE_VIEW[d.medicalType],
          assigneeTypeView: TRAINEE_TYPE[d.assigneeType],
          medicalCategoryName: d?.medicalCategoryData?.name,
          medicalSubCategoryName: d?.medicalCategoryData?.subCategory?.find(
            (sub) => sub.id === d?.medicalSubCategory
          )?.name,

          assigneeID: d?.medicalAssigneeData?.srNo || d?.medicalAssigneeData?.employeeId,
          assigneeName: `${d?.medicalAssigneeData?.firstName} ${d?.medicalAssigneeData?.lastName}`,
          assigneeDesignation:
            d?.medicalAssigneeData?.srNo || d?.medicalAssigneeData?.employeeId,
          formA:
            d?.medicalAssigneeData?.srNo ||
            d?.medicalAssigneeData?.employeeFormA?.serialNumberOmc,

          dueDateView: DDMMYYYYFormat(d?.dueDate),
          medicalTestTypeView: MEDICAL_TYPE_VIEW[d?.medicalTestType],
          medicalAssigneeTypeView: TRAINEE_TYPE[d?.medicalAssigneeType],
        };
      }),
    },
  };
};

export async function myMedical(filter) {
  let url = "/global-configuration/ehs-module/myvlf" + (filter ? `?${filter}` : "");
  const result = await CallApi(url, "GET");

  const { status, message, data } = result;

  return {
    status,
    message,
    data: Array.isArray(data)
      ? data.map((d, index) => {
          return {
            ...d,
            sid: index + 1,
            medicalScheduledDateTimeView: YYYYMMDDHHMMAFormat(d.medicalScheduledDateTime),
            mineName: d?.siteData?.name,
          };
        })
      : data,
  };
}

export async function getMedicalByID(id) {
  let url = "/global-configuration/ehs-module/get-medical-assigners-by-id/" + id;
  return await CallApi(url, "GET");
}

export async function createMedical(data) {
  let url = "/global-configuration/ehs-module/create-medical-assigners";

  let response = await CallApi(url, "POST", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MEDICAL_ALL,
      data: [],
    });
  }
  return response;
}

export async function updateMedical(id, data) {
  let url = "/global-configuration/ehs-module/update-medical-assigners/" + id;
  let response = await CallApi(url, "PUT", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MEDICAL_ALL,
      data: [],
    });
  }
  return response;
}

export async function updateMedicalByMedicalOfficer(data) {
  let url = "global-configuration/ehs-module/vlf-execution/";
  return await CallApi(url, "POST", data);
}

export async function updateMedicalCapa(id, data) {
  let url = "/global-configuration/ehs-module/medical-closer/" + id;
  return await CallApi(url, "PUT", data);
}

export async function deleteMedical(id, data) {
  let url = "/global-configuration/ehs-module/vlf/" + id;
  return await CallApi(url, "DELETE", data);
}

export async function downloadMedicalCertificate(id) {
  let url = "/global-configuration/ehs-module/download-medical-certificate/" + id;
  return await CallApi(url, "GET");
}

export async function allMedicalAssignersCount() {
  let url = "/global-configuration/ehs-module/all-medical-assigners-count";

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
